import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["submitButton", "roundsInput"]

  connect() {
    this.roundsInputTarget.addEventListener("input", this.checkConditions.bind(this))
  }

  disconnect() {
    this.roundsInputTarget.removeEventListener("input", this.checkConditions.bind(this))
  }

  checkConditions() {
    const currentRound = parseInt(this.element.dataset.currentRound, 10)
    const auctionStatus = this.element.dataset.auctionStatus
    const roundsValue = parseInt(this.roundsInputTarget.value, 10)

    const isWarningConditionMet = 
      roundsValue === currentRound && auctionStatus == "round_complete"

    if (isWarningConditionMet) {
      this.submitButtonTarget.setAttribute("data-turbo-confirm", "Are you sure you want to update the rounds to match the current round? This will complete the auction. No further assets will be awarded.")
    } else {
      this.submitButtonTarget.removeAttribute("data-turbo-confirm")
    }
  }
}
